// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c1s7","colMin":"styles_colMin__2Bg4s"};